import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

import ArshImage from '../../assets/images/profiles/trainees/Arsh.jpeg'
import AtifImage from '../../assets/images/profiles/trainees/Atif.jpeg'
import NabilaImage from '../../assets/images/profiles/trainees/Nabila.jpg'
import SohailImage from '../../assets/images/profiles/trainees/Sohail.jpeg'

// Sample trainee data
const traineesData = [
    {
        name: "Arsh Khan", testimonials: `I recently completed the one-month Frontend Development
course by Pronttera, and it was a highly practical and insightful
experience. The course, designed by industry experts, covered
HTML, CSS, JavaScript, and ReactJS, providing a clear
understanding of how these technologies are applied in realworld scenarios. The trainers were knowledgeable, patient,
and always willing to address doubts, making the learning
process smooth and enjoyable. The daily assignments were
well-structured and helped me steadily improve my skills.
Overall, it was a valuable experience that I would highly
recommend to anyone looking to build a strong foundation in
frontend development`, image: ArshImage
    },

    {
        name: "Nabila Sayyed", testimonials: `Joining Pronttera bootcamp has been a truly meaningful
and fulfilling experience.. The program is highly engaging,
with a focus on practical, real-world applications.
Regular assignments, interactive doubt-clearing sessions,
and insightful guest lectures from technology experts
ensure I stay updated with industry trends and fully grasp
the concepts.
The mentors are supportive, and the structured approach
keeps everything on track...
Pronttera is a great choice for anyone looking for practical
learning and consistent support in front-end web
technologies to develop their skills.`, image: NabilaImage
    },
    {
        name: "Atif Pathan", testimonials: `I had the privilege of attending the bootcamp
organized by Pronttera, and I must say it was an
enriching experience. The trainers were highly
knowledgeable, patient, and passionate about
teaching. They broke down complex concepts in
HTML, CSS, and JavaScript into easy-to-understand
modules, ensuring that every participant, regardless
of their experience level, could follow along. The
hands-on approach and real-world examples helped
me gain confidence in applying these skills. I highly
recommend this bootcamp to anyone looking to
strengthen their foundation in web development!`, image: AtifImage
    },
    {
        name: "Sohel Ansari", testimonials: `The bootcamp class exceeded my expectations with
its well-structured curriculum and engaging teaching
methods. The instructors were knowledgeable,
approachable, and always ready to assist with any
doubts. One of the highlights was the guest lecture,
where an industry expert shared valuable insights and
practical tips, making the session incredibly enriching.
The hands-on projects helped reinforce concepts and
boosted my confidence in applying them. The
collaborative learning environment and peer
interactions added to the overall experience. I would
highly recommend this bootcamp to anyone looking
to enhance their skills and grow professionally!
`, image: SohailImage
    },
];

const TraineesCarousel = () => {
    return (
        <div className=" bg-yellow-100">
            <section className="relative section">
                {/* Section Title */}
                <div className="md:mb-12 mb-6">
                    <p className="text-xs uppercase font-semibold text-gray-500">Meet Our Rising Stars</p>
                    <h2 className="text-2xl font-medium text-gray-800">See What They've Achieved with Us ✨</h2>
                </div>

                {/* Navigation Buttons */}
                <div className="absolute top-1/2 left-0 z-10 mt-4 -translate-y-1/2">
                    <button className="swiper-button-prev  p-3 rounded-full ">
                        <FaChevronLeft className="text-lg text-gray-700" />
                    </button>
                </div>

                <div className="absolute top-1/2 right-0 z-10 mt-4 -translate-y-1/2">
                    <button className="swiper-button-next  p-3 rounded-full ">
                        <FaChevronRight className="text-lg text-gray-700" />
                    </button>
                </div>


                {/* Swiper Carousel */}
                <Swiper
                    spaceBetween={16}
                    navigation={{
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }}
                    modules={[Navigation]}
                    loop
                    breakpoints={{
                        320: { slidesPerView: 1 },  // Mobile View: 1 card
                        640: { slidesPerView: 1 },  // Tablet View: 1 cards
                        1024: { slidesPerView: 1 }  // Desktop View: 1 cards
                    }}
                    className="max-w-[60rem] mx-auto"
                >
                    {traineesData.map((trainee, index) => (
                        <SwiperSlide key={index}>
                            <div className="bg-white rounded-3xl shadow-md overflow-hidden flex gap-4 flex-col md:flex-row">
                                <img src={trainee.image} alt={trainee.name} className="md:w-full md:h-96 md:mt-0 mt-6 w-28 h-28 md:rounded-none rounded-2xl self-center object-cover aspect-square " />
                                <div className="mt-4 p-4 mb-4">
                                    <h3 className="text-xl font-semibold mb-4">{trainee.name}</h3>
                                    <p className="text-gray-600 max-h-60 md:max-h-none lg:max-h-none overflow-auto">"{trainee.testimonials}"</p>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </section>
        </div>

    );
};

export default TraineesCarousel;
